import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import debounce from 'lodash/debounce'

import Navbar from 'react-bootstrap/Navbar'
import PropTypes from 'prop-types'

import CurrentTime from '../CurrentTime/index'
import HeaderNav from '../HeaderNav/index'
import Logo from '../Logo/index'
import MobileNavMenu from '../MobileNavMenu/index'
import SearchInput from 'components/SearchInput'
import DropdownButton, { DropdownItem } from 'components/Dropdown'
import { logout } from 'store/modules/auth'
import './MainHeader.scss'

const MainHeader = ({ logout }) => {
  const [shadow, setShadow] = useState(false)

  const handleScroll = debounce(() => setShadow(window.scrollY > 0), 200)
  const sensorList = ["Station: Swiss Ave | WA_MH16_WM_3746", "Station: Marshall Ave | WA_MH16_WM_3746", "Station: German Ave | WA_MH16_WM_3746"];

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [handleScroll])

  return (
    <Navbar collapseOnSelect fixed="top" expand="md" className={cn('MainHeader', { 'MainHeader--shadow': shadow })}>
      <Navbar.Brand href="/landing" className="d-md-none">
        <Logo />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse className='head-content'>
        <DropdownButton title={ sensorList[0] } className="d-none d-md-flex">
          {sensorList &&
            sensorList.map((sensor, key) => (
              <DropdownItem key={key}>
                {sensor}
              </DropdownItem>
            ))}
        </DropdownButton>
        <SearchInput
          type="text"
          placeholder="Search"
          autoComplete="off"
          className="ml-2 OverviewMap__search d-none d-md-flex"
        />
      </Navbar.Collapse>
      <Navbar.Collapse className="ml-2 justify-content-end">
        <Navbar.Text className="d-none d-md-flex">
          <CurrentTime />
        </Navbar.Text>
        <Navbar.Text className="d-none d-md-flex p-0">
          <HeaderNav />
        </Navbar.Text>

        <MobileNavMenu className="d-block d-md-none" />
      </Navbar.Collapse>
    </Navbar>
  )
}

MainHeader.propTypes = {
  logout: PropTypes.func.isRequired
}

const actions = {
  logout
}

export default connect(
  null,
  actions
)(MainHeader)
